import axios from 'axios'


function fetch(query = {}){
	const params = Object.assign({},query)
	return axios(params)
			.then(function (response) {
				const { data, status } = response
				if (data.code === -200 || status >= 400) {
					return Promise.reject(res);
				}
				return data;
			})
			.catch(function (error) {
				const proxy = {};
				
				proxy.name = '接口请求异常';
				proxy.message = error.message;
				
				if (error.response && error.response.data) {
					return Promise.reject(error.response.data);
				}
				
				return Promise.reject(proxy);
			})
	
}

export function post(url, data = {}, headers = {}) {
    return new Promise((resolve,reject)=>{
		try{
			resolve(fetch({url, data, method: 'post', headers}))
		}catch(error){
			reject(error)
		}
	})
}
